import { useEffect, useMemo } from "react";

const envScriptMap = new Map<string, string>([
    ["UAT", "https://rbictg.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-ia3qmx/b/5/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=9cf91aba"],
    ["Stage", "https://rbictg.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-ia3qmx/b/4/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=0e78caf8"]
]);

const currentEnvSrc = envScriptMap.get(process.env.REACT_APP_ENV!)

/**
 * Embeds the UAT Jira issue collector widget
 */
const useJiraIssueCollector = () => {
    const script = useMemo(() => {
        const s = document.createElement('script');
        s.src = currentEnvSrc!;
        s.async = true;
        return s;
    }, []);

    useEffect(() => {
        document.head.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, [script]);
}

export default currentEnvSrc ? useJiraIssueCollector : () => {};